import { render, staticRenderFns } from "./AddDependents.vue?vue&type=template&id=780ea26a&scoped=true&"
import script from "./AddDependents.vue?vue&type=script&lang=js&"
export * from "./AddDependents.vue?vue&type=script&lang=js&"
import style0 from "./AddDependents.vue?vue&type=style&index=0&id=780ea26a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780ea26a",
  null
  
)

export default component.exports